export default "__VITE_ASSET__DJWZY4FC__"